









































































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import KpiFolderMainPopup from './KpiFolderMainPopup.vue';
import KpiFolderSubPopup from './KpiFolderSubPopup.vue';



@Component({
  components: {
    KpiFolderMainPopup,
    KpiFolderSubPopup,
  }
})
export default class KpiFolder extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;
  public queryForm: Record<string, any> = {
    pages: 1,
    size: 10,
    current: 1,
    total: 0,
    createTimeRange: [],
    name: ''
  }
  public tableData: any[] = [];
  public loading: Boolean = true;
  public isShowPopup1: Boolean = false; // 是否显示主目录popup
  public isShowPopup2: Boolean = false; // 是否显示子目录popup
  public popupId1: Number = null;
  public popupId2: Number = null;
  public popupKey1: number = 0; // 主目录弹窗key，用于强制重新渲染
  public popupKey2: number = 0; // 子目录弹窗key，用于强制重新渲染

  public async created(): Promise<void> {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      createTimeRange: [],
      name: ''
    }
    await this.getList();
  }

  //查询接口
  public search() {
    this.queryForm.current = 1;
    this.getList()
  }

  //分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  //获取数据接口（复用主目录管理列表的接口）
  public async getList() {
    this.loading = true;
    let params: any = {
      name: this.queryForm.name,
      createDateStart: (this.queryForm.createTimeRange || [])[0],
      createDateEnd: (this.queryForm.createTimeRange || [])[1],
      current: this.queryForm.current,
      size: this.queryForm.size
    };

    try {
      const res = await this.nuoxiaoerService.fetchKpiFolderList(params);
      this.loading = false;
      const list = (res.records || []).map(x => {
        return {
          ...x,
          createdTime: x.createdTime ? moment(x.createdTime).format('YYYY-MM-DD HH:mm:ss') : '--',
          sortNumber: typeof x.sortNumber === 'number' ? x.sortNumber : '--',
        }
      });
      this.tableData = list;
      this.queryForm.total = res.total || 0;
      this.queryForm.pages = res.pages || 0;
      this.queryForm.size = res.size || 10;
      this.queryForm.current = res.current || 1;
    } catch (error) {
      this.loading = false;
      console.error('获取KPI主目录列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  /* 打开新增主目录popup */
  public handleOpenCreatePopup() {
    this.popupKey1++; // 强制重新渲染组件
    this.isShowPopup1 = true;
  }
  /* 编辑主目录 */
  public handleEditFolder(rowData) {
    console.log('编辑主目录 rowData:', rowData);
    this.popupId1 = rowData.id;
    this.popupKey1++; // 强制重新渲染组件
    this.isShowPopup1 = true;
  }

  /* 保存后 */
  public handleAfterSaved(type: 'MAIN' | 'SUB') {
    console.log('handleAfterSaved type:', type);
    this.getList();
    if (type === 'MAIN') {
      this.isShowPopup1 = false;
      this.popupId1 = null;
    }
    if (type === 'SUB') {
      this.isShowPopup2 = false;
      this.popupId2 = null;
    }
  }

  /* 取消popup */
  public handleCancelPopup(type: 'MAIN' | 'SUB') {
    console.log('handleCancelPopup type:', type);
    if (type === 'MAIN') {
      this.isShowPopup1 = false;
      this.popupId1 = null;
    }
    if (type === 'SUB') {
      this.isShowPopup2 = false;
      this.popupId2 = null;
    }
  }

  /* 关闭popup后 */
  public handleAfterClosePopup(type: 'MAIN' | 'SUB') {
    console.log('handleAfterClosePopup type:', type);
    if (type === 'MAIN') {
      this.popupId1 = null;
      this.popupKey1++; // 强制重新渲染组件，清理状态
    }
    if (type === 'SUB') {
      this.popupId2 = null;
      this.popupKey2++; // 强制重新渲染组件，清理状态
    }
  }

  /* 打开子目录popup */
  public handleOpenSubPopup(rowData: any) {
    console.log('打开子目录popup row:', rowData);
    this.popupId2 = rowData.id;
    this.popupKey2++; // 强制重新渲染组件
    this.isShowPopup2 = true;
  }

  /* 删除主目录 */
  private async handleDelete(row: any): Promise<void> {
    try {
      // 先检查是否有子目录
      const childResult = await this.nuoxiaoerService.fetchKpiFolderChildList({ id: row.id });
      if (childResult && childResult.kpiFolderVOList && childResult.kpiFolderVOList.length > 0) {
        this.$message({
          message: '该主目录下有关联子目录，无法删除！',
          type: 'warning'
        });
        return;
      }

      // 确认删除
      await this.$confirm('是否删除该信息？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });

      await this.nuoxiaoerService.deleteKpiFolder({ id: row.id });
      this.getList();
      this.$message({
        message: '删除成功',
        type: 'success'
      });
    } catch (e) {
      if (e === 'cancel') {
        console.log('取消删除');
      }
      this.$message({
        type: 'info',
        message: '已取消删除'
      });
    }
  }

  // 重置筛选搜索
  public handleResetSearch() {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      createTimeRange: [],
      name: ''
    };
    this.getList();
  }
}
